import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const deleteVariantAPI = createApi("DeleteVariantSlice", 'DELETE');

const DeleteVariantSlice = createSlice({
  name: 'DeleteVariantSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteVariantAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteVariantAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteVariantAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeleteVariantSlice.reducer;